import Image from 'next/image';
import IconWhite from './purchase_white.svg?url';
import type { SvgImageProps } from '../types';

export const PurchaseWhiteImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={IconWhite} alt={alt} {...props} />;
